// src/components/common/ChartWrapper/ChartWrapper.jsx
import { Box, Typography } from "@mui/material";
import Loading from "../../Loading";

const ChartWrapper = ({ isLoading, isEmpty, height = "350px", children }) => {
  if (isLoading) {
    return (
      <Box
        height={height}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Loading />
      </Box>
    );
  }

  if (isEmpty) {
    return (
      <Box
        height={height}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography variant="body2" color="text.secondary">
          No data available
        </Typography>
      </Box>
    );
  }

  return children;
};

export default ChartWrapper;
